import { Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import { PrimaryButton } from '@components/atoms/PrimaryButton/PrimaryButton';

const { Title, Paragraph } = Typography;


export const ServicesPage = () => {
  const navigate = useNavigate();
  
  return (
    <div>
      {/* Hero Section */}
      <section className="relative w-full h-[400px]">
        <div className="services-bg opacity-60 absolute inset-0 w-full h-full"></div>
        <div className="container relative h-full flex flex-col justify-center items-center mx-auto px-4 py-12 md:py-16 lg:py-20 z-10">
          <Title level={1} className="font-android !font-normal text-yellow-principal text-center">
            OUR SERVICES
          </Title>
          <div className="max-w-3xl mx-auto">
            <Paragraph className="font-barlow text-gray-300 text-center md:text-lg lg:!text-xl">
              Comprehensive excavation and construction solutions for projects of all sizes.
            </Paragraph>
          </div>
        </div>
      </section>
      
      {/* Main Services */}
      <section className="w-full pt-8 pb-18 bg-second-black-carbon">
        <div className="container mx-auto relative z-10">
          <Title level={2} className="font-android !font-normal text-yellow-principal text-center text-2xl md:text-3xl lg:text-4xl mb-4 mt-4">
            WHAT WE OFFER
          </Title>          
          <Paragraph className="font-barlow text-gray-300 text-center max-w-xl mx-auto md:pb-12">
                      At Estabrook Inc., we provide a wide range of excavation and construction services to meet the needs of residential, commercial, and industrial clients throughout the region.
          </Paragraph>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 mx-4 md:mx-auto">
            <div className="flex flex-col p-6 bg-first-dark-gray">
              <div className="mb-5">
                <img 
                  src="/assets/icons/Heavy-Construction-Icon-Yellow-Box.png" 
                  alt="Excavation" 
                  className="w-12 h-12 md:w-16 md:h-16 bg-yellow-principal"
                />
              </div>
              <Title level={4} className="!text-white font-android !font-normal text-lg md:text-xl">EXCAVATION</Title>
              <Paragraph className="font-barlow text-gray-300 mb-3">
                Professional excavation services for residential and commercial projects with precision and safety.
              </Paragraph>
              {/* <a 
                onClick={(e) => { e.preventDefault(); navigate('/services'); window.scrollTo(0, 0); }}
                className="text-yellow-principal font-barlow mt-auto text-sm w-fit"
              >
                Learn more <img src="/assets/icons/carry-right.svg" alt="bullet" className="w-2 h-2 inline-block ml-1 pb-[2px]" />
              </a> */}
            </div>
            
            <div className="flex flex-col p-6 bg-first-dark-gray">
              <div className="mb-5">
                <img 
                  src="/assets/icons/Residential-Construction-Icon-Yellow-Box.png" 
                  alt="Site Preparation" 
                  className="w-12 h-12 md:w-16 md:h-16 bg-yellow-principal"
                />
              </div>
              <Title level={4} className="!text-white font-android !font-normal text-lg md:text-xl">SITE PREPARATION</Title>
              <Paragraph className="font-barlow text-gray-300 text-xs md:text-sm mb-3">
                Complete site preparation including grading, drainage solutions, and foundation preparation.
              </Paragraph>
              {/* <a 
                onClick={(e) => { e.preventDefault(); navigate('/services'); window.scrollTo(0, 0); }}
                className="text-yellow-principal font-barlow mt-auto text-sm w-fit"
              >
                Learn more <img src="/assets/icons/carry-right.svg" alt="bullet" className="w-2 h-2 inline-block ml-1 pb-[2px]" />
              </a> */}
            </div>
            
            <div className="flex flex-col p-6 bg-first-dark-gray">
              <div className="mb-5">
                <img 
                  src="/assets/icons/Snow-Removal-Icon-Yellow-Box.png" 
                  alt="Commercial Snow Removal" 
                  className="w-12 h-12 md:w-16 md:h-16 bg-yellow-principal"
                />
              </div>
              <Title level={4} className="!text-white font-android !font-normal text-lg md:text-xl">COMMERCIAL SNOW REMOVAL</Title>
              <Paragraph className="font-barlow text-gray-300 text-xs md:text-sm mb-3">
                Reliable commercial snow removal services to keep your business accessible during winter months.
              </Paragraph>
              {/* <a 
                onClick={(e) => { e.preventDefault(); navigate('/services'); window.scrollTo(0, 0); }}
                className="text-yellow-principal font-barlow mt-auto text-sm w-fit"
              >
                Learn more <img src="/assets/icons/carry-right.svg" alt="bullet" className="w-2 h-2 inline-block ml-1 pb-[2px]" />
              </a> */}
            </div>
          </div>
          
          {/* <div className="flex justify-center mt-8 md:mt-8">
            <PrimaryButton 
              size="large" 
              onClick={() => { navigate('/services'); window.scrollTo(0, 0); }}
              className="w-auto"
            >
              LEARN MORE
            </PrimaryButton>
          </div> */}
        </div>
      </section>

      <section className="w-full h-full bg-first-dark-gray pb-8 md:pb-12">
        <div className="container mx-auto px-4">          
          <div className="flex flex-col md:flex-row gap-6 md:gap-10">
            <div className="md:w-1/2 pt-4 md:pt-6">
              <div className="mt-3">
                <Title level={2} className="font-android !font-normal text-yellow-principal pb-4 md:pb-6 text-2xl md:text-3xl lg:text-4xl">
                COMMERCIAL SNOW REMOVAL
                </Title>
                <Paragraph className="font-barlow text-gray-300 text-sm md:text-base text-justify">
                Our commercial snow removal services keep your business accessible and safe during winter months in the Truckee-Tahoe region. We understand that snow can significantly impact your operations, which is why we offer reliable and efficient snow removal solutions.
                </Paragraph>
                <Paragraph className="font-barlow text-gray-300 text-sm md:text-base text-justify pb-4">
                With our fleet of specialized equipment and experienced operators, we ensure that your parking lots, driveways, and walkways are cleared quickly and thoroughly, minimizing disruption to your business.
                </Paragraph>
                
                <div className="text-gray-300 mb-6">
                  <div className="flex items-start mb-4">
                    <span className="mr-2">
                      <img src="/assets/icons/carry-right.svg" alt="bullet" className="w-5 h-5 pt-[2px]" />
                    </span>
                    <span className="font-barlow text-sm md:text-base">24/7 emergency snow removal</span>
                  </div>
                  <div className="flex items-start mb-4">
                    <span className="mr-2">
                      <img src="/assets/icons/carry-right.svg" alt="bullet" className="w-5 h-5 pt-[2px]" />
                    </span>
                    <span className="font-barlow text-sm md:text-base">Seasonal contracts available</span>
                  </div>
                  <div className="flex items-start mb-4">
                    <span className="mr-2">
                      <img src="/assets/icons/carry-right.svg" alt="bullet" className="w-5 h-5 pt-[2px]" />
                    </span>
                    <span className="font-barlow text-sm md:text-base">De-icing and anti-icing treatments</span>
                  </div>
                  <div className="flex items-start mb-4">
                    <span className="mr-2">
                      <img src="/assets/icons/carry-right.svg" alt="bullet" className="w-5 h-5 pt-[2px]" />
                    </span>
                    <span className="font-barlow text-sm md:text-base">Snow hauling and relocation</span>
                  </div>
                </div>

                <div className="flex justify-center md:justify-start my-8 md:my-12">
                  <PrimaryButton 
                    size="large" 
                    onClick={() => { navigate('/quote'); window.scrollTo(0, 0); }}
                    className="w-auto"
                  >
                  REQUEST A QUOTE
                  </PrimaryButton>
                </div>
              </div>
            </div>
            
            <div className="md:w-1/2 flex items-center justify-center">
              <div className="overflow-hidden">
                <img 
                  src="/assets/images/snow-removal.png" 
                  alt="About Estabrook" 
                  className="w-full h-auto max-h-[800px] object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Our Equipment Section */}
      <section className="w-full pt-8 pb-16 bg-second-black-carbon">
        <div className="container mx-auto px-4">
          <Title level={2} className="font-android !font-normal text-yellow-principal text-center text-2xl md:text-3xl lg:text-4xl mb-4 mt-4">
            OUR EQUIPMENT
          </Title>
          <Paragraph className="font-barlow text-gray-300 text-center max-w-3xl mx-auto md:pb-12">
            We maintain a modern fleet of well-maintained equipment to handle projects of all sizes efficiently and safely.
          </Paragraph>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {/* Card 1: Excavators */}
            <div className="flex flex-col bg-first-dark-gray p-6">
              <div className="mb-4 h-48 bg-zinc-700 flex items-center justify-center">
                {/* Image placeholder. Replace with the real image path when available. E.g. <img src="/assets/images/excavator.jpg" alt="Excavators" className="w-full h-full object-cover" /> */}
                <svg className="w-16 h-16 text-gray-500" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" viewBox="0 0 24 24" stroke="white"><path d="M3.75 6A2.25 2.25 0 016 3.75h12A2.25 2.25 0 0120.25 6v12A2.25 2.25 0 0118 20.25H6A2.25 2.25 0 013.75 18V6zM3 16.036C3 16.526 3.432 17 3.934 17H6v-4.559L3 16.036zM21 16.036L18 12.441V17h2.066C20.568 17 21 16.526 21 16.036zM18 7.5H6V17h12V7.5zM12 11.25a3 3 0 100-6 3 3 0 000 6z"></path></svg>
              </div>
              <Title level={4} className="font-android !font-normal !text-white text-lg md:text-xl mb-2">EXCAVATORS</Title>
              <Paragraph className="font-barlow text-gray-300 text-xs md:text-sm">
                Various sized excavators for different project requirements, from compact models for tight spaces to larger machines for major earthmoving.
              </Paragraph>
            </div>

            {/* Card 2: Bulldozers */}
            <div className="flex flex-col bg-first-dark-gray p-6">
              <div className="mb-4 h-48 bg-zinc-700 flex items-center justify-center">
                <svg className="w-16 h-16 text-gray-500" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" viewBox="0 0 24 24" stroke="white"><path d="M3.75 6A2.25 2.25 0 016 3.75h12A2.25 2.25 0 0120.25 6v12A2.25 2.25 0 0118 20.25H6A2.25 2.25 0 013.75 18V6zM3 16.036C3 16.526 3.432 17 3.934 17H6v-4.559L3 16.036zM21 16.036L18 12.441V17h2.066C20.568 17 21 16.526 21 16.036zM18 7.5H6V17h12V7.5zM12 11.25a3 3 0 100-6 3 3 0 000 6z"></path></svg>
              </div>
              <Title level={4} className="font-android !font-normal !text-white text-lg md:text-xl mb-2">BULLDOZERS</Title>
              <Paragraph className="font-barlow text-gray-300 text-xs md:text-sm">
                Powerful bulldozers for efficient earth moving, grading, and site preparation on projects of all sizes.
              </Paragraph>
            </div>
            
            {/* Card 3: Backhoes */}
            <div className="flex flex-col bg-first-dark-gray p-6">
              <div className="mb-4 h-48 bg-zinc-700 flex items-center justify-center">
                <svg className="w-16 h-16 text-gray-500" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" viewBox="0 0 24 24" stroke="white"><path d="M3.75 6A2.25 2.25 0 016 3.75h12A2.25 2.25 0 0120.25 6v12A2.25 2.25 0 0118 20.25H6A2.25 2.25 0 013.75 18V6zM3 16.036C3 16.526 3.432 17 3.934 17H6v-4.559L3 16.036zM21 16.036L18 12.441V17h2.066C20.568 17 21 16.526 21 16.036zM18 7.5H6V17h12V7.5zM12 11.25a3 3 0 100-6 3 3 0 000 6z"></path></svg>
              </div>
              <Title level={4} className="font-android !font-normal !text-white text-lg md:text-xl mb-2">BACKHOES</Title>
              <Paragraph className="font-barlow text-gray-300 text-xs md:text-sm">
                Versatile backhoe loaders that combine the digging capabilities of an excavator with the loading capabilities of a front loader.
              </Paragraph>
            </div>

            {/* Card 4: Dump Trucks */}
            <div className="flex flex-col bg-first-dark-gray p-6">
              <div className="mb-4 h-48 bg-zinc-700 flex items-center justify-center">
                <svg className="w-16 h-16 text-gray-500" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" viewBox="0 0 24 24" stroke="white"><path d="M3.75 6A2.25 2.25 0 016 3.75h12A2.25 2.25 0 0120.25 6v12A2.25 2.25 0 0118 20.25H6A2.25 2.25 0 013.75 18V6zM3 16.036C3 16.526 3.432 17 3.934 17H6v-4.559L3 16.036zM21 16.036L18 12.441V17h2.066C20.568 17 21 16.526 21 16.036zM18 7.5H6V17h12V7.5zM12 11.25a3 3 0 100-6 3 3 0 000 6z"></path></svg>
              </div>
              <Title level={4} className="font-android !font-normal !text-white text-lg md:text-xl mb-2">DUMP TRUCKS</Title>
              <Paragraph className="font-barlow text-gray-300 text-xs md:text-sm">
                Fleet of dump trucks for efficient material hauling, debris removal, and site cleanup.
              </Paragraph>
            </div>

            {/* Card 5: Skid Steers */}
            <div className="flex flex-col bg-first-dark-gray p-6">
              <div className="mb-4 h-48 bg-zinc-700 flex items-center justify-center">
                <svg className="w-16 h-16 text-gray-500" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" viewBox="0 0 24 24" stroke="white"><path d="M3.75 6A2.25 2.25 0 016 3.75h12A2.25 2.25 0 0120.25 6v12A2.25 2.25 0 0118 20.25H6A2.25 2.25 0 013.75 18V6zM3 16.036C3 16.526 3.432 17 3.934 17H6v-4.559L3 16.036zM21 16.036L18 12.441V17h2.066C20.568 17 21 16.526 21 16.036zM18 7.5H6V17h12V7.5zM12 11.25a3 3 0 100-6 3 3 0 000 6z"></path></svg>
              </div>
              <Title level={4} className="font-android !font-normal !text-white text-lg md:text-xl mb-2">SKID STEERS</Title>
              <Paragraph className="font-barlow text-gray-300 text-xs md:text-sm">
                Compact, highly maneuverable skid steer loaders for working in confined spaces and handling various attachments.
              </Paragraph>
            </div>

            {/* Card 6: Snow Removal Equipment */}
            <div className="flex flex-col bg-first-dark-gray p-6">
              <div className="mb-4 h-48 bg-zinc-700 flex items-center justify-center">
                <svg className="w-16 h-16 text-gray-500" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" viewBox="0 0 24 24" stroke="white"><path d="M3.75 6A2.25 2.25 0 016 3.75h12A2.25 2.25 0 0120.25 6v12A2.25 2.25 0 0118 20.25H6A2.25 2.25 0 013.75 18V6zM3 16.036C3 16.526 3.432 17 3.934 17H6v-4.559L3 16.036zM21 16.036L18 12.441V17h2.066C20.568 17 21 16.526 21 16.036zM18 7.5H6V17h12V7.5zM12 11.25a3 3 0 100-6 3 3 0 000 6z"></path></svg>
              </div>
              <Title level={4} className="font-android !font-normal !text-white text-lg md:text-xl mb-2">SNOW REMOVAL EQUIPMENT</Title>
              <Paragraph className="font-barlow text-gray-300 text-xs md:text-sm">
                Specialized equipment for commercial snow removal, including plows, snow blowers, and salt/sand spreaders.
              </Paragraph>
            </div>
          </div>
        </div>
      </section>
      
      {/* CTA */}
      <section className="w-full pt-8 pb-16 bg-first-dark-gray">
        <div className="container mx-auto px-4 text-center mt-4">
          <Title level={2} className="font-android !font-normal text-yellow-principal">NEED OUR SERVICES?</Title>
          <Paragraph className="font-barlow text-gray-300 text-xl py-4">
            Contact us today to discuss your project requirements and get a detailed quote from our team.
          </Paragraph>
          <div className="flex flex-wrap justify-center gap-6 md:gap-12">
            <PrimaryButton
              size="large" 
              onClick={() => { navigate('/quote'); window.scrollTo(0, 0); }}
              className="w-auto">
              GET A QUOTE
          </PrimaryButton>
          {/* <PrimaryButton
              size="large" 
              onClick={() => navigate('/projects')}
              className="w-auto">
              VIEW OUR PROJECTS
            </PrimaryButton> */}
          </div>
        </div>
      </section>

      {/* Quote process
      <section className="w-full py-20 bg-black">
        <div className="container mx-auto px-4">
          <Title level={2} className="!text-white text-center mb-16 font-android">OUR PROCESS</Title>
          
          <div className="relative max-w-4xl mx-auto">
            <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-0.5 bg-yellow-pincipal -ml-0.5"></div>
            
            {/* Step 1 
            <div className="relative mb-16">
              <div className="md:flex items-center">
                <div className="hidden md:block w-1/2 pr-8 text-right">
                  <Title level={3} className="!text-white mb-4 font-android">INITIAL CONSULTATION</Title>
                  <Paragraph className="text-gray-300" style={paragraphStyle}>
                    We begin with a thorough consultation to understand your project needs, goals, and specifications.
                  </Paragraph>
                </div>
                <div className="md:absolute md:left-1/2 md:top-1/2 md:-translate-y-1/2 md:-ml-6 z-10 mb-4 md:mb-0">
                  <div className="bg-yellow-pincipal text-black w-12 h-12 rounded-full flex items-center justify-center text-xl font-bold">1</div>
                </div>
                <div className="md:w-1/2 md:pl-8 md:text-left">
                  <Title level={3} className="!text-white mb-4 md:hidden font-android">INITIAL CONSULTATION</Title>
                  <Paragraph className="text-gray-300 md:hidden" style={paragraphStyle}>
                    We begin with a thorough consultation to understand your project needs, goals, and specifications.
                  </Paragraph>
                  <img 
                    src="/service-consultation.jpg" 
                    alt="Initial Consultation" 
                    className="rounded-lg w-full"
                    onError={(e) => {
                      e.currentTarget.src = 'https://placehold.co/600x400?text=Consultation';
                    }}
                  />
                </div>
              </div>
	          {/* Step 2 
            <div className="relative mb-16">
              <div className="md:flex items-center">
                <div className="md:w-1/2 md:pr-8 md:text-right">
                  <img 
                    src="/service-planning.jpg" 
                    alt="Project Planning" 
                    className="rounded-lg w-full"
                    onError={(e) => {
                      e.currentTarget.src = 'https://placehold.co/600x400?text=Planning';
                    }}
                  />
                </div>
                <div className="md:absolute md:left-1/2 md:top-1/2 md:-translate-y-1/2 md:-ml-6 z-10 mb-4 md:mb-0">
                  <div className="bg-yellow-pincipal text-black w-12 h-12 rounded-full flex items-center justify-center text-xl font-bold">2</div>
                </div>
                <div className="md:w-1/2 md:pl-8 md:text-left">
                  <Title level={3} className="!text-white mb-4 font-android">PROJECT PLANNING</Title>
                  <Paragraph className="text-gray-300" style={paragraphStyle}>
                    Our team develops a detailed project plan, including timeline, resource allocation, and budget considerations.
                  </Paragraph>
                </div>
              </div>
	          {/* Step 3 
            <div className="relative">
              <div className="md:flex items-center">
                <div className="hidden md:block w-1/2 pr-8 text-right">
                  <Title level={3} className="!text-white mb-4 font-android">EXECUTION & COMPLETION</Title>
                  <Paragraph className="text-gray-300" style={paragraphStyle}>
                    We execute the project with precision and attention to detail, keeping you informed throughout the process.
                  </Paragraph>
                </div>
                <div className="md:absolute md:left-1/2 md:top-1/2 md:-translate-y-1/2 md:-ml-6 z-10 mb-4 md:mb-0">
                  <div className="bg-yellow-pincipal text-black w-12 h-12 rounded-full flex items-center justify-center text-xl font-bold">3</div>
                </div>
                <div className="md:w-1/2 md:pl-8 md:text-left">
                  <Title level={3} className="!text-white mb-4 md:hidden font-android">EXECUTION & COMPLETION</Title>
                  <Paragraph className="text-gray-300 md:hidden" style={paragraphStyle}>
                    We execute the project with precision and attention to detail, keeping you informed throughout the process.
                  </Paragraph>
                  <img 
                    src="/service-execution.jpg" 
                    alt="Execution & Completion" 
                    className="rounded-lg w-full"
                    onError={(e) => {
                      e.currentTarget.src = 'https://placehold.co/600x400?text=Execution';
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>*/}
    </div>
  );
}; 